import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import Card from '../_library/Card'
import BulkInvoiceForm from './BulkInvoiceForm'
import { FETCH_EVENT } from '../../_common/redux/events/actions'
import { clearCurrentInvoice } from '../../_common/redux/bulkInvoices/actions'

const BulkInvoiceCreatePage = ({ match, history, event, fetchEvent, clearCurrentInvoice }) => {
  const eventId = match.params.id

  useEffect(() => {
    // Clear any existing invoice data when creating a new invoice
    clearCurrentInvoice()
    
    if (eventId && !event) {
      fetchEvent(eventId)
    }
  }, [eventId, event, fetchEvent, clearCurrentInvoice])

  const handleSuccess = (invoiceId) => {
    if (invoiceId) {
      // Navigate to the newly created invoice view page
      history.push(`/event/${eventId}/bulk-invoices/${invoiceId}`)
    } else {
      // Fallback to list if no ID
      history.push(`/event/${eventId}/bulk-invoices`)
    }
  }

  const handleCancel = () => {
    // Navigate back to the bulk invoices list
    history.push(`/event/${eventId}/bulk-invoices`)
  }

  return (
    <div>
      <Card title="Create New Bulk Invoice">
        <BulkInvoiceForm
          event={event}
          onSuccess={handleSuccess}
          onCancel={handleCancel}
        />
      </Card>
    </div>
  )
}

const mapStateToProps = state => ({
  event: state.events.selected
})

const mapDispatchToProps = dispatch => ({
  fetchEvent: (eventId) => dispatch(FETCH_EVENT(eventId)),
  clearCurrentInvoice: () => dispatch(clearCurrentInvoice())
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BulkInvoiceCreatePage))
